import { Component, OnInit } from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';

import { LanguageHelper, deepCopy } from '../../../shared';
import { Account, User } from '../../../models';
import { AccountService, Principal } from '../../../services';

@Component({
    selector: 'qms-user-settings',
    templateUrl: './settings.component.html'
})
export class SettingsComponent implements OnInit {
    public nameMinLength = User.NAME_MIN_LENGTH;
    public nameMaxLength = User.NAME_MAX_LENGTH; // TODO: move to user constants
    public emailMinLength = User.EMAIL_MIN_LENGTH;
    public emailMaxLength = User.EMAIL_MAX_LENGTH;

    public account: Account;
    public success: boolean;
    public languages: string[];

    constructor(private accountService: AccountService,
                private principal: Principal,
                private languageService: JhiLanguageService,
                private languageHelper: LanguageHelper) {
    }

    ngOnInit() {
        this.principal.identity().then((account: Account) => {
            this.account = deepCopy(account);
        });
        this.languageHelper.getAll().then((languages: string[]) => {
            this.languages = languages;
        });
    }

    public save() {
        this.success = null;
        this.accountService.update(this.account).subscribe(() => {
            this.principal.identity(true).then((account: Account) => {
                this.account = deepCopy(account);
            });
            this.languageService.getCurrent().then((current: string) => {
                if (this.account.langKey !== current) {
                    this.languageService.changeLanguage(this.account.langKey);
                }
            });
            this.success = true;
        }, () => {
            this.success = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/account/settings/settings.component.ts